enum FeedItemType {
  POLL = "poll",
  RECOGNITION = "recognition",
  GROUP_RECOGNITION = "group_recognition"
}

export default FeedItemType
